import { useMemo, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'

import { Header, Tabs } from '@/components'
import { ROUTES_ADMIN } from '@/router'

import { HostConversationList } from './host-conversation/host-conversation'
import styles from './lead-intake.module.css'

export const LeadIntake = () => {
    const { t } = useTranslation('screenLeadIntake')

    const location = useLocation()
    const page = location.pathname.split('/').pop()

    const navigate = useNavigate()

    const object: Record<string, ReactNode> = {
        'host-conversations': <HostConversationList />,
    }

    const tabs = useMemo(() => {
        return [
            {
                title: t('tabHostConversation'),
                isActive: page === 'host-conversations',
                onSelect: () =>
                    navigate(ROUTES_ADMIN.LEAD_INTAKE.HOST_CONVERSATION.fullPath()),
            },
        ]
    }, [page, navigate, t])

    return (
        <div>
            <Header
                title={t('title')}
                description={t('description')}
            />

            <div className={styles.content}>
                <Tabs items={tabs} />

                {object?.[page as keyof typeof object]}
            </div>
        </div>
    )
}
